import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { NewhomepageService } from './newhomepage.service';
import { CommonLatestNewsComponent } from 'src/app/shared/components/latest-news/latest-news.component';
import { NewheroheaderComponent } from './newheroheader/newheroheader.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';
@Component({
  selector: 'app-newhomepage',
  templateUrl: './newhomepage.component.html',
  styleUrls: ['./newhomepage.component.scss'],
  imports: [
    NewheroheaderComponent
  ]
})
export class NewhomepageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  pageData: any;
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: ''
  }
  constructor(
    private homePageService: NewhomepageService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  ngOnInit(): void {
    this.homePageService.getNewHomePageData();

    const data = this.route.snapshot.data['seo']?.[0]?.fields;
    if (data) {
      this.pageData = data;
      this.meta.updateMeta(
        this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
          ?.fields
      );
      this.canonical.setCanonicalURL();
      this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
      this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
      this.metaBody.type = 'Verto';
      this.metaBody.url = this.getUrl;
      this.metaBody.image =
        data?.psHeroPanel[0]?.fields?.image[0]?.fields?.file?.url;
      this.meta.updateOG(this.metaBody);
    }

    this.posthogService.capturePageViewEvent('home');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
